import { render, staticRenderFns } from "./InputCheckbox.vue?vue&type=template&id=d32bd4d4"
import script from "./InputCheckbox.vue?vue&type=script&lang=ts"
export * from "./InputCheckbox.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports